export const CONST_CURRENCY = {
    GET_CURRENCY:'GET_CURRENCY',
}